import { render } from "./NotFound.vue?vue&type=template&id=563601a2&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.css?vue&type=style&index=0&id=563601a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563601a2"]])

export default __exports__